import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import checked from "../../img/checked.svg";
import checkedDisabled from "../../img/checked-disabled.svg";
import deleteImg from "../../img/delete.svg";
import deleteImgDisabled from "../../img/delete-disabled.svg";
import cancel from "../../img/cancel.svg";
import cancelDisabled from "../../img/cancel-disabled.svg";
import loading from "../../img/loading.svg";
import { DragSource, DropTarget } from "react-dnd";

var Types = {
  ROW: "row",
};

const rowSource = {
  beginDrag(props) {
    return { id: props.id, index: props.index };
  },
};

const rowTarget = {
  drop(props, monitor, component) {
    props.saveNewOrder();
  },
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    //const rawComponent = component.getDecoratedComponentInstance();

    //    console.log(rawComponent); //.node.getBoundingClientRect());
    const hoverBoundingRect = component.node.getBoundingClientRect(); //component.getBoundingClientRect();
    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%
    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    props.moveRow(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

function sourceCollect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}

function targetCollect(connect) {
  return {
    connectDropTarget: connect.dropTarget(),
  };
}

class EditRdvType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      typing: false,
      editing: false,
      element: null,
      empty: false,
      loading: false,
      isPublic: this.props.slotType.role === "SECRETARY" ? false : true,
      label: this.props.slotType.name,
      duration: this.props.slotType.duration,
      message: this.props.slotType.infos,
    };
  }

  handleLabel = (event) => {
    this.setState(
      {
        label: event.target.value,
      },
      this.handleChange
    );
  };

  handleDuration = (event) => {
    this.setState(
      {
        duration: event.target.value,
      },
      this.handleChange
    );
  };
  handleIsPublic = (event) => {
    this.setState(
      {
        isPublic: event.target.checked,
      },
      this.handleChange
    );
  };

  handleIndexUpdate = async (id, index) => {
    this.props.updateSlotTypeIndexMutation({
      variables: { id, index },
    });
    /*  .then(resp => {
        this.props.refetch();
      })
      .catch(e => {
        console.error("updaterdvtype", e);
      });
    this.setState({
      loading: false,
      editing: false
    });*/
  };

  handleMessage = (event) => {
    this.setState(
      {
        message: event.target.value,
      },
      this.handleChange
    );
  };
  handleDelete = () => {
    this.props.toggleConfirm();
    this.props.setHandleCancel(this.handleRealDelete);
  };

  handleRealDelete = async () => {
    const id = this.props.slotType.id;
    const role = "HIDDEN";
    const name = this.props.slotType.name + " (effacé)";
    await this.props
      .updateSlotTypeMutation({
        variables: { id, role, name },
      })
      .then((resp) => {
        this.props.refetch();
        this.props.toggleConfirm();
        let selectedRdvTypeId = null;
        let selectedRdvTypeDuration = null;
        let selectedDoctorId = null;
        this.props
          .updateRdvSelectType({
            variables: {
              selectedRdvTypeId,
              selectedRdvTypeDuration,
              selectedDoctorId,
            },
          })
          .catch((e) => {
            console.error("update local state", e);
          });
      })
      .catch((e) => {
        console.error("delete slottype", e);
      });
  };

  handleChange = () => {
    if (this.state.label.length < 1 || this.state.duration.length < 1) {
      this.setState({
        empty: true,
      });
    } else {
      this.setState({
        empty: false,
      });
    }
  };

  handleUpdate = async () => {
    const { label, isPublic, message } = this.state;
    const role = isPublic ? "PUBLIC" : "SECRETARY";
    this.setState({
      loading: true,
    });
    const name = label;
    const duration = parseInt(this.state.duration, 10);
    const infos = message;
    const id = this.props.slotType.id;
    await this.props
      .updateSlotTypeMutation({
        variables: { id, name, duration, role, infos },
      })
      .then((resp) => {
        this.props.refetch();
      })
      .catch((e) => {
        console.error("updaterdvtype", e);
      });
    this.setState({
      loading: false,
      editing: false,
    });
  };

  editing = () => {
    this.setState({
      editing: true,
    });
  };

  handleCancel = () => {
    this.setState({
      editing: false,
    });
  };

  editRow = () => {
    let save = this.state.empty ? (
      <figure className="image is-32x32">
        <img alt="checkedDisabled" src={checkedDisabled} />
      </figure>
    ) : (
      <figure onClick={this.handleUpdate} className="image is-32x32">
        <img alt="checked" src={checked} />
      </figure>
    );
    let remove = this.state.empty ? (
      <figure className="image is-32x32">
        <img alt="deleteImgDisabled" src={deleteImgDisabled} />
      </figure>
    ) : (
      <figure onClick={this.handleDelete} className="image is-32x32">
        <img alt="deleteImg" src={deleteImg} />
      </figure>
    );
    if (this.state.loading) {
      save = (
        <figure className="image is-32x32">
          <img alt="loading" src={loading} />
        </figure>
      );
    }
    let cancelbtn = this.state.empty ? (
      <figure className="image is-32x32">
        <img alt="cancelDisabled" src={cancelDisabled} />
      </figure>
    ) : (
      <figure onClick={this.handleCancel} className="image is-32x32">
        <img alt="cancel" src={cancel} />
      </figure>
    );

    return (
      <tr>
        <td />
        <td>
          <input
            className="input"
            placeholder="libellé"
            onChange={this.handleLabel}
            value={this.state.label}
          />
        </td>
        <td>
          <label className="checkbox">
            <input
              type="checkbox"
              checked={this.state.isPublic}
              onChange={this.handleIsPublic}
            />
          </label>
        </td>
        <td>
          <input
            className="input"
            placeholder="15"
            onChange={this.handleDuration}
            value={this.state.duration}
          />
        </td>
        <td>
          <textarea
            className="textarea"
            placeholder="infos"
            onChange={this.handleMessage}
            value={this.state.message}
          />
        </td>
        <td>
          {save} {cancelbtn} {remove}
        </td>
      </tr>
    );
  };

  render() {
    const slotType = this.props.slotType;
    let slotTypeIndex = this.props.index + 1;

    if (this.state.editing === false) {
      const {
        isDragging,
        connectDragSource,
        connectDropTarget,
        connectDragPreview,
      } = this.props;
      const opacity = isDragging ? 0 : 1;
      return (
        connectDropTarget &&
        connectDragSource &&
        connectDragPreview(
          connectDropTarget(
            <tr
              ref={(node) => (this.node = node)}
              key={slotType.id}
              //      handleIndexUpdate={this.handleIndexUpdate}
              onClick={this.editing}
              style={{
                opacity: opacity,
              }}
            >
              {connectDragSource(
                <td className="grabbable">
                  <label className="grabbable">{slotTypeIndex}</label>
                </td>
              )}

              <td>
                <span className="input">{slotType.name}</span>
              </td>
              <td>
                <label className="checkbox">
                  <input
                    type="checkbox"
                    readOnly={true}
                    disabled={true}
                    checked={slotType.role === "SECRETARY" ? false : true}
                  />
                </label>
              </td>
              <td>
                <span className="input">{slotType.duration}</span>
              </td>
              <td>
                <p className="textarea disabled-textarea">{slotType.infos}</p>
              </td>
              <td />
            </tr>
          )
        )
      );
    }
    return this.editRow();
  }
}

const UPDATE_RDVTYPE_MUTATION = gql`
  mutation UpdateSlotTypeMutation(
    $id: ID!
    $name: String
    $duration: Int
    $infos: String
    $role: Role
  ) {
    updateSlotType(
      id: $id
      name: $name
      duration: $duration
      infos: $infos
      role: $role
    ) {
      id
    }
  }
`;

const DELETE_RDVTYPE_MUTATION = gql`
  mutation DeleteSlotTypeMutation($id: ID!) {
    deleteSlotType(id: $id) {
      id
    }
  }
`;
const UPDATE_RDV_SELECT_TYPE = gql`
  mutation updateRDVSelectTypeDoc(
    $selectedRdvTypeId: String
    $selectedRdvTypeDuration: Int
    $selectedDoctorId: ID
  ) {
    updateRDVSelectTypeDoc(
      selectedRdvTypeId: $selectedRdvTypeId
      selectedRdvTypeDuration: $selectedRdvTypeDuration
      selectedDoctorId: $selectedDoctorId
    ) @client
  }
`;

//var source = DragSource(Types.ROW, rowSource, sourceCollect)(DraggableRow);
//var row = DropTarget(Types.ROW, rowTarget, targetCollect)(source);

export default compose(
  graphql(UPDATE_RDVTYPE_MUTATION, {
    name: "updateSlotTypeMutation",
  }),
  graphql(UPDATE_RDV_SELECT_TYPE, {
    name: "updateRdvSelectType",
  }),
  graphql(DELETE_RDVTYPE_MUTATION, {
    name: "deleteSlotTypeMutation",
  }),
  DragSource(Types.ROW, rowSource, sourceCollect),
  DropTarget(Types.ROW, rowTarget, targetCollect)
)(EditRdvType);



// WEBPACK FOOTER //
// ./src/components/utilities/EditRdvType.js